@use '@design/components/custom-scroll/custom-scroll' as *;

.tabContent {
  padding: 12px;
  background-color: var(--surface-default);
  display: flex;
  width: 100%;
  justify-content: space-between;
  align-items: center;
}

.wrapper {
  z-index: 1;
  height: 100%;
  display: flex;
  flex-direction: column;
}

.tableWrapper {
  @include custom-scroll-minimal;

  position: relative;
  overflow: auto;
  flex: 1 1 0;

  table {
    tbody {
      tr > td:nth-child(n + 2) {
        font-family: var(--font-roboto-mono);
      }
    }
  }

  &::-webkit-scrollbar-track {
    margin-left: 207px;
  }
}

.emptyStateWrapper {
  display: flex;
  height: 100%;
}

.tableLoaderWrapper {
  height: 100%;
}

.tableLoader {
  height: 100%;
}

.assetCell {
  display: flex;
}

.cellWithChartContainer {
  display: flex;
  align-items: center;
  gap: 24px;
  justify-content: space-between;
}
